module.exports = __webpack_public_path__ + "img/83.bfc73d41.jpg";